module.exports = __webpack_public_path__ + "static/media/private-lock.b09400e0.svg";